import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Footer from './components/Footer';
import ShareButtons from './components/ShareButtons';
import CookieConsent from './components/CookieConsent';
import JumbleSolver from './games/JumbleSolver';
import SudokuSolver from './games/SudokuSolver';
import WordleGame from './games/WordleGame';
import AnagramSolver from './games/AnagramSolver';
import CrosswordSolver from './games/CrosswordSolver';
import AnagramGenerator from './games/AnagramGenerator';
import WordUnscrambler from './games/WordUnscrambler';
import WordleSolver from './games/WordleSolver';
import HangmanGame from './games/HangmanGame';
import WordSearch from './games/WordSearch';
import BoggleSolver from './games/BoggleSolver';
import ScrabbleFinder from './games/ScrabbleFinder';
import WordLadder from './games/WordLadder';
import RhymeFinder from './games/RhymeFinder';
import PalindromeChecker from './games/PalindromeChecker';
import SpellingBeeSolver from './games/SpellingBeeSolver';
import LongestWordFinder from './games/LongestWordFinder';
import WordPatternFinder from './games/WordPatternFinder';
import ScrabbleCalculator from './games/ScrabbleCalculator';
import PigLatinConverter from './games/PigLatinConverter';
import WordScramble from './games/WordScramble';
import WordChain from './games/WordChain';
import SyllableCounter from './games/SyllableCounter';
import WordCounter from './games/WordCounter';
import CryptogramSolver from './games/CryptogramSolver';
import MorseCode from './games/MorseCode';
import Dordle from './games/Dordle';
import Quordle from './games/Quordle';
import Connections from './games/Connections';
import RandomWordGenerator from './games/RandomWordGenerator';
import PangramChecker from './games/PangramChecker';
import WordTwist from './games/WordTwist';
import TextTwistSolver from './games/TextTwistSolver';
import WaffleGame from './games/WaffleGame';
import WordBloom from './games/WordBloom';
import LetterBoxed from './games/LetterBoxed';
import WordfeudHelper from './games/WordfeudHelper';
import About from './components/About';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';
import NotFound from './components/NotFound';
import ScrollToTop from './components/ScrollToTop';

export default function App() {
  return (
    <HelmetProvider>
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <ScrollToTop />
        <Navbar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/jumble" element={<JumbleSolver />} />
            <Route path="/sudoku" element={<SudokuSolver />} />
            <Route path="/wordle" element={<WordleGame />} />
            <Route path="/anagram-solver" element={<AnagramSolver />} />
            <Route path="/crossword" element={<CrosswordSolver />} />
            <Route path="/anagram-generator" element={<AnagramGenerator />} />
            <Route path="/unscramble" element={<WordUnscrambler />} />
            <Route path="/wordle-solver" element={<WordleSolver />} />
            <Route path="/hangman" element={<HangmanGame />} />
            <Route path="/word-search" element={<WordSearch />} />
            <Route path="/boggle" element={<BoggleSolver />} />
            <Route path="/scrabble" element={<ScrabbleFinder />} />
            <Route path="/word-ladder" element={<WordLadder />} />
            <Route path="/rhyme" element={<RhymeFinder />} />
            <Route path="/palindrome" element={<PalindromeChecker />} />
            <Route path="/spelling-bee" element={<SpellingBeeSolver />} />
            <Route path="/longest-word" element={<LongestWordFinder />} />
            <Route path="/word-pattern" element={<WordPatternFinder />} />
            <Route path="/scrabble-calculator" element={<ScrabbleCalculator />} />
            <Route path="/pig-latin" element={<PigLatinConverter />} />
            <Route path="/word-scramble" element={<WordScramble />} />
            <Route path="/word-chain" element={<WordChain />} />
            <Route path="/syllable-counter" element={<SyllableCounter />} />
            <Route path="/word-counter" element={<WordCounter />} />
            <Route path="/cryptogram" element={<CryptogramSolver />} />
            <Route path="/morse-code" element={<MorseCode />} />
            <Route path="/dordle" element={<Dordle />} />
            <Route path="/quordle" element={<Quordle />} />
            <Route path="/connections" element={<Connections />} />
            <Route path="/random-word-generator" element={<RandomWordGenerator />} />
            <Route path="/pangram-checker" element={<PangramChecker />} />
            <Route path="/word-twist" element={<WordTwist />} />
            <Route path="/text-twist-solver" element={<TextTwistSolver />} />
            <Route path="/waffle" element={<WaffleGame />} />
            <Route path="/wordbloom" element={<WordBloom />} />
            <Route path="/letter-boxed" element={<LetterBoxed />} />
            <Route path="/wordfeud-helper" element={<WordfeudHelper />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <ShareButtons />
        <Footer />
        <CookieConsent />
      </div>
    </Router>
    </HelmetProvider>
  );
}
